import React from 'react';
import { createRoot } from 'react-dom/client'
import './index.css';
import App from './App';
import {UserProvider} from "./context/UserContext";
// import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root')

if (!container) {
    throw new Error('Root container missing')
}

const root = createRoot(container)
root.render(
    <React.StrictMode>
        <UserProvider>
            <App />
        </UserProvider>
    </React.StrictMode>
);
